import { AddressVm } from './AddressVm'
import { DriverLicenseVm } from './DriverLicenseVm'

export class PersonVm{
    Id: number = 0;
    Cpr: string = "";
    FirstName: string = "";
    LastName: string = "";
    CprStatus: string = "";
    Address: AddressVm = new AddressVm();
    DriverLicense: DriverLicenseVm = new DriverLicenseVm();
}